

import { defineComponent } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  mounted () {
    if (this.Tabs.length > 0) {
      this.$router.push(this.Tabs[0].Link as any)
    }
  },
  data () {
    return {}
  },
  computed: {
    Name () {
      return this.Translate('Exports')
    },
    Tabs () {
      var Tabs = [
        { Name: this.Translate('All Exports'), Link: '/Reports/Inventory/Exports/All', Access: this.Access('Inventory_Transfers_Read') },
        { Name: this.Translate('Items Exports'), Link: '/Reports/Inventory/Exports/Items', Access: this.Access('Inventory_Transfers_Read') },
        { Name: this.Translate('Categories Exports'), Link: '/Reports/Inventory/Exports/Categories', Access: this.Access('Inventory_Transfers_Read') },
        { Name: this.Translate('Brands Exports'), Link: '/Reports/Inventory/Exports/Brands', Access: this.Access('Inventory_Transfers_Read') }
      ] as Array<CookiesTabs>
      return Tabs.filter(tab => {
        return tab.Access
      })
    }
  },
  methods: {},
  watch: {}
})
